import xss from 'xss'

// 这是edit富文本框配置
export const editXss = () => {
  const options = {
    whiteList: {
      a: ['target', 'href', 'title'],
      abbr: ['title'],
      address: [],
      area: ['shape', 'coords', 'href', 'alt'],
      article: [],
      aside: [],
      audio: ['autoplay', 'controls', 'loop', 'preload', 'src'],
      b: [],
      bdi: ['dir'],
      bdo: ['dir'],
      big: [],
      blockquote: ['cite'],
      br: [],
      caption: [],
      center: [],
      cite: [],
      code: [],
      col: ['align', 'valign', 'span', 'width'],
      colgroup: ['align', 'valign', 'span', 'width'],
      dd: [],
      del: ['datetime'],
      details: ['open'],
      div: [],
      dl: [],
      dt: [],
      em: [],
      font: ['color', 'size', 'face'],
      footer: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      header: [],
      hr: [],
      i: [],
      img: ['src', 'alt', 'title', 'width', 'height', 'style'],
      ins: ['datetime'],
      li: [],
      mark: [],
      nav: [],
      ol: [],
      p: [],
      pre: [],
      s: [],
      section: [],
      small: [],
      span: ['style'],
      strong: [],
      sub: [],
      sup: [],
      table: ['width', 'border', 'align', 'valign'],
      tbody: ['align', 'valign'],
      td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
      tfoot: ['align', 'valign'],
      th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
      thead: ['align', 'valign'],
      tr: ['rowspan', 'align', 'valign'],
      tt: [],
      u: [],
      ul: [],
      video: ['autoplay', 'controls', 'loop', 'preload', 'src', 'height', 'width']
    }
  }
  const myxss = new xss.FilterXSS(options)
  return myxss
}

/**
 * 伴学助手 Markdown 渲染：在 editXss 白名单基础上允许脚注、任务列表、KaTeX 等所需属性。
 */
export const aiAssistantMarkdownXss = () => {
  const base = editXss()
  const src = base.options.whiteList
  const wl = {}
  for (const key of Object.keys(src)) {
    wl[key] = src[key].slice()
  }
  const merge = (tag, attrs) => {
    wl[tag] = [...new Set([...(wl[tag] || []), ...attrs])]
  }
  merge('a', ['id', 'class'])
  merge('span', ['class'])
  merge('sup', ['class'])
  merge('hr', ['class'])
  merge('ol', ['class', 'start'])
  merge('ul', ['class'])
  merge('li', ['class', 'id'])
  merge('p', ['class'])
  merge('section', ['class'])
  merge('code', ['class'])
  merge('sub', ['class', 'style'])
  /* KaTeX 可见 HTML 中含 SVG（大括号、积分号等）；未放行则整段被滤掉，表现为公式错位 */
  wl.svg = [
    'xmlns',
    'width',
    'height',
    'viewBox',
    'preserveAspectRatio',
    'class',
    'style',
    'fill',
    'stroke',
    'stroke-width',
    'focusable',
    'aria-hidden',
    'x',
    'y'
  ]
  wl.path = ['d', 'class', 'style', 'fill', 'stroke', 'stroke-width', 'stroke-linecap', 'stroke-linejoin']
  wl.line = ['x1', 'y1', 'x2', 'y2', 'class', 'style', 'fill', 'stroke', 'stroke-width']
  wl.g = ['class', 'style', 'transform', 'fill', 'stroke']
  wl.input = ['type', 'checked', 'disabled', 'class']
  /*
   * KaTeX 在 span 的 style 里大量使用 position/top/left/height 等做排版。
   * xss 内置 cssfilter 默认白名单会剔除这些属性，导致公式内部严重错位。
   * css: false 关闭属性级 CSS 过滤，仍走 safeAttrValue 对 expression、javascript: 等的拦截。
   */
  return new xss.FilterXSS({ whiteList: wl, css: false })
}

// 这是默认配置
export const defaultOptions = {
  a: ['target', 'href', 'title'],
  abbr: ['title'],
  address: [],
  area: ['shape', 'coords', 'href', 'alt'],
  article: [],
  aside: [],
  audio: ['autoplay', 'controls', 'loop', 'preload', 'src'],
  b: [],
  bdi: ['dir'],
  bdo: ['dir'],
  big: [],
  blockquote: ['cite'],
  br: [],
  caption: [],
  center: [],
  cite: [],
  code: [],
  col: ['align', 'valign', 'span', 'width'],
  colgroup: ['align', 'valign', 'span', 'width'],
  dd: [],
  del: ['datetime'],
  details: ['open'],
  div: [],
  dl: [],
  dt: [],
  em: [],
  font: ['color', 'size', 'face'],
  footer: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  header: [],
  hr: [],
  i: [],
  img: ['src', 'alt', 'title', 'width', 'height'],
  ins: ['datetime'],
  li: [],
  mark: [],
  nav: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  section: [],
  small: [],
  span: [],
  strong: [],
  sub: [],
  sup: [],
  table: ['width', 'border', 'align', 'valign'],
  tbody: ['align', 'valign'],
  td: ['width', 'rowspan', 'colspan', 'align', 'valign'],
  tfoot: ['align', 'valign'],
  th: ['width', 'rowspan', 'colspan', 'align', 'valign'],
  thead: ['align', 'valign'],
  tr: ['rowspan', 'align', 'valign'],
  tt: [],
  u: [],
  ul: [],
  video: ['autoplay', 'controls', 'loop', 'preload', 'src', 'height', 'width']
}



// WEBPACK FOOTER //
// ./src/assets/config/xss.js